import React from 'react';
import Setting from "../../image/Setting.svg";
import Alert from "../../image/Alert.svg";
import Popup from 'reactjs-popup';
import { Button, DialogContent, DialogContentText } from '@mui/material';
import { Link } from 'react-router-dom';
import MailIcon from '../../Components/MainIcons/MailIcon';

const Reports = (props) => {


  function logout() {

    props.state.keycloak.logout();

  }


  return (
    <div>
      <div className="EvidenceTaskNavbar">
        <div>
          <span className="EvidenceTitle">Reports</span>
        </div>
        <div>
        <MailIcon state={props.state} />
        </div>
      </div>
    </div>
  )
}

export default Reports